import React, { lazy } from 'react';
import { Menu, MenuItem } from '@mui/material';
import { observer } from 'mobx-react';
const TreeNodeInfoDlg = lazy(() => import('./dialogs/TreeNodeInfoDlg'));
const TreeMenu = observer(function ({ node, onClose, model, }) {
    var _a, _b;
    const { structures } = model;
    const nodeDetails = node ? model.getRowData(node.name) : undefined;
    return (React.createElement(React.Fragment, null,
        React.createElement(Menu, { anchorReference: "anchorPosition", anchorPosition: {
                top: node.y,
                left: node.x,
            }, transitionDuration: 0, keepMounted: true, open: Boolean(node), onClose: onClose },
            React.createElement(MenuItem, { dense: true, disabled: true }, node.name),
            React.createElement(MenuItem, { dense: true, onClick: () => {
                    model.queueDialog(onClose => [
                        TreeNodeInfoDlg,
                        {
                            info: model.getRowData(node.name),
                            model,
                            nodeName: node.name,
                            onClose,
                        },
                    ]);
                    onClose();
                } }, "More info..."), (_a = structures[node.name]) === null || _a === void 0 ? void 0 :
            _a.map(entry => {
                return !model.selectedStructures.some(n => n.id === node.name) ? (React.createElement(MenuItem, { key: JSON.stringify(entry), dense: true, onClick: () => {
                        model.addStructureToSelection({
                            structure: entry,
                            id: node.name,
                        });
                        onClose();
                    } },
                    "Add PDB to selection (",
                    entry.pdb,
                    ")")) : (React.createElement(MenuItem, { key: JSON.stringify(entry), dense: true, onClick: () => {
                        model.removeStructureFromSelection({
                            structure: entry,
                            id: node.name,
                        });
                        onClose();
                    } },
                    "Remove PDB from selection (",
                    entry.pdb,
                    ")"));
            }), // @ts-expect-error
        (_b = nodeDetails === null || nodeDetails === void 0 ? void 0 : nodeDetails.data.accession) === null || _b === void 0 ? void 0 :
            _b.map(accession => (React.createElement(MenuItem, { dense: true, key: accession, onClick: () => {
                    model.addUniprotTrack({
                        // @ts-expect-error
                        name: nodeDetails === null || nodeDetails === void 0 ? void 0 : nodeDetails.data.name,
                        accession,
                    });
                    onClose();
                } },
                "Open UniProt track (",
                accession,
                ")"))))));
});
export default TreeMenu;
//# sourceMappingURL=TreeMenu.js.map